import { OWN_BUILD } from './buildCheck';

export const API = '/api';

export function authFetch(url: string, options: RequestInit = {}) {
  const token = localStorage.getItem('wms_token') || '';
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      'Authorization': `Bearer ${token}`,
      // the page's own version: the inventory's Start refuses an outdated page once fresh clients are required
      'X-WMS-Build': OWN_BUILD,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    },
  });
}
